// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".profile-card-title[data-v-691ca504]{position:relative}.profile-card-title[data-v-691ca504]:before{content:\"\";position:absolute;right:6px;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%);width:3px;height:24px;background:#1e90ff;border-radius:8px}", ""]);
// Exports
module.exports = exports;
